import {Dropdown, Select} from "antd";
import React, {useEffect, useState} from "react";
import classes from './AdvancedSearch.module.scss';
import axios from '../../../services/axios';

function AdvancedSearch({children, onGroupSelected, onVisibleChange, ...props}) {

    const [studentGroups, setStudentGroups] = useState([]);
    const [errorLoadingStudentGroups, setErrorLoadingStudentGroups] = useState(null);
    const [loadingStudentGroups, setLoadingStudentGroups] = useState(false);

    const [selectedValues, setSelectedValues] = useState({});

    const selectors = [
        {
            label: 'Факультет',
            id: 'faculty',
            dependencies: [],
            components: ['faculty'],
            allowSearch: false,
            getOption: (group) => ({
                label: group.faculty.name,
                value: JSON.stringify({ faculty: group.faculty })
            })
        },
        {
            label: 'Специальность',
            id: 'sdef',
            dependencies: ['faculty'],
            components: ['speciality', 'educationDegree', 'educationForm'],
            allowSearch: true,
            getOption: (group) => {
                const sdefObj = {
                    speciality: group.speciality,
                    educationDegree: group.educationDegree,
                    educationForm: group.educationForm
                }
                return {
                    label: `${sdefObj.speciality.name}, ${sdefObj.educationDegree.name} ступень, ${sdefObj.educationForm.name}`,
                    value: JSON.stringify(sdefObj)
                }
            }
        },
        {
            label: 'Курс',
            id: 'course',
            dependencies: ['sdef'],
            components: ['course'],
            allowSearch: false,
            getOption: (group) => ({
                label: group.course.name,
                value: JSON.stringify({ course: group.course })
            })
        },
        {
            label: 'Группа',
            id: 'studentGroup',
            dependencies: ['sdef', 'course'],
            components: ['studentGroup'],
            allowSearch: false,
            getOption: (group) => ({
                label: group.studentGroup.name,
                value: JSON.stringify({ studentGroup: group.studentGroup })
            })
        },
    ];

    useEffect(() => {
        setLoadingStudentGroups(true);
        setErrorLoadingStudentGroups(null);
        axios.get('/api/v1/schedule/student-groups/advanced-search')
            .then((response) => {
                setStudentGroups(response.data);
            })
            .catch(_error => {
                setErrorLoadingStudentGroups('Не удалось загрузить группы студентов');
            })
            .finally(() => {
                setLoadingStudentGroups(false);
            });


    }, []);

    const areNamedItemsEqual = (item1, item2) => {
        if (!item1 || !item2) return false;
        return item1.id === item2.id && item1.name === item2.name;
    }

    const filterStudentGroups = (selectorId) => {
        const filterDef = selectors.find(s => s.id === selectorId);
        return studentGroups.filter(group => {

            return filterDef.dependencies.every(d => {
                const dependentSelector = selectors.find(s => s.id === d);
                return dependentSelector.components.every(component =>
                    areNamedItemsEqual(group[component], selectedValues[component]));
            });
        });
    }

    const getOptionsForSelector = (id) => {
        const selectorDefinition = selectors.find(selector => selector.id === id);
        
        const filteredGroups = filterStudentGroups(id);
        
        const options = [];
        filteredGroups.forEach(group => {
            const option = selectorDefinition.getOption(group);
            if (!options.find(existing => existing.value === option.value)) {
                options.push(option);
            }
        });
        options.sort((a, b) => a.label.localeCompare(b.label));
        return options;
    }

    const isSelectorDisabled = (id) => {
        const selectorDef = selectors.find(s => s.id === id);
        return selectorDef.dependencies.some(dep => {
            const dependentSelector = selectors.find(s => s.id === dep);
            return !dependentSelector.components.every(component => !!selectedValues[component]);
        })
    }

    const getSelectorValueById = (id) => {
        const selectorDef = selectors.find(s => s.id === id);
        let valueObj = {};
        for (const component of selectorDef.components) {
            if (!selectedValues[component]) {
                return null;
            }
            valueObj = { ...valueObj, [component]: selectedValues[component] };
        }
        return JSON.stringify(valueObj);
    }

    const onOptionSelected = (id, value) => {
        const selectedObj = JSON.parse(value);
        if (id === 'studentGroup') {
            onGroupSelected(selectedObj);
        }

        const newSelectedValues = {}
        selectors.forEach(s => {
            if (s.id !== id && s.dependencies.find(dep => dep === id)) {
                s.components.forEach(c => {
                    newSelectedValues[c] = null;
                })
            }
        });
        setSelectedValues(previous => ({ ...previous, ...newSelectedValues, ...selectedObj }));
    }

    const dropdownContent = () => (<div className={classes.container}>
        {selectors.map((selector, index) => (
            <Select
                className={classes.select}
                key={`groupSelector${index}`}
                showSearch={selector.allowSearch}
                defaultActiveFirstOption={true}
                placeholder={selector.label}
                options={getOptionsForSelector(selector.id)}
                value={getSelectorValueById(selector.id)}
                onChange={value => onOptionSelected(selector.id, value)}
                disabled={isSelectorDisabled(selector.id)}
            />))}
    </div>);

    return (<Dropdown
        trigger={['click']}
        placement='bottomRight'
        overlayClassName={classes.overlayClass}
        {...props}
        overlay={dropdownContent}
        onVisibleChange={onVisibleChange}>
        {children}
    </Dropdown>);
}

export default AdvancedSearch;